<template>
    <div>
      <app-header class="haeder-r"></app-header>
        <!--slider end -->


        <section  class="blog full-page">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 col-xs-12 col-sm-12 ">
                        <div class="box-title">
                            <h2 class="text-center" v-lang.blog></h2>
                        </div>
                        <ul class="animatedParent animateOnce" data-sequence="500">
                            <li class="col-md-4 col-xs-12 col-sm-6 animated bounceInUp go" data-id="1" v-for="blog in blogs">
                                <a  :href="/blogs/+blog.slug"><div class="box-img" :style="'background-image: url('+ blog.image+')'"></div></a>
                                <div class="box-text">
                                <h4 v-for="category in blog.category">{{category.name}}</h4>
                                <a  :href="/blogs/+blog.slug"><h3>{{blog.title}}</h3></a>
                                <time><i class="fa fa-clock-o" aria-hidden="true"></i> {{blog.created_date}}</time>
                                <a  :href="/blogs/+blog.slug">{{blog.description}}</a>
                                </div>
                                <div class="box-link">
                                <a :href="/blogs/+blog.slug" v-lang.readmore></a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
      <app-footer></app-footer>
    </div>
</template>

<script>
 import {Urls,checkForDub} from '../config'
  export default {
    mounted(){
        this.getBlogs()
    },
    data(){
        return{
            blog : {},
            loading : false,
            pagination : {}
        }
    },
    methods:{
          getBlogs(link){
          this.loading = true
          this.axios.get(Urls.blogsUrl+'?pages=8&language='+this.language)
              .then((response) => {
              // Success
              this.loading = false
              if(response.status === 200){
                  this.pagination = response.data.meta
                  response.data.data.forEach(blog => {
                  if(! checkForDub(this.blogs,blog,'slug')){
                      this.$store.commit('blog/add', blog)
                  }
                  })
              }
              }).catch((errors) => {
              // error
              this.loading = false
              console.log(errors)
              this.err = errors
          })
        },

        findItInCash(slug){
            let arr = this.blogs
          for(var i = 0; i < arr.length; i++) {
            if(arr[i].slug === data.slug) {
              this.blog = arr[i]
              return true;
            }else{
              return false;
            }
          }
        },
        date(data){
            var blogDate = new Date(data);
             return blogDate.getDay() + '/' + blogDate.getMonth()  + '/' + blogDate.getFullYear();
        },
             getIndexPage(index){
            this.$store.commit('blog/clear')
          this.getBlogs(Urls.blogsUrl + "?page=" + index)
        },
        getNextPage(){
          if(parseInt(this.pagination.current_page) < parseInt(this.pagination.last_page)) {
            this.$store.commit('blog/clear')
            let nextPageNum = parseInt(this.pagination.current_page) + 1
              this.getBlogs(Urls.blogsUrl + "?page=" + nextPageNum)
          }
        },
        getPrevPage(){
            if(parseInt(this.pagination.current_page) > 1){
              this.$store.commit('blog/clear')
              let prevPageNum = parseInt(this.pagination.current_page) - 1
              this.getBlogs(Urls.blogsUrl + "?page=" + prevPageNum)
            }
        },
    },
    computed:{
       blogs(){
            return this.$store.state.blog.blog
        },
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/blogs.vue